module.exports = __webpack_public_path__ + "img/dialog_complete.0339ca7e.gif";